
var stepNumber = 1;
var specialCrate = null;

class subscriptionFunnel {
  constructor(){
    const params = new URLSearchParams(window.location.search);
    if (params.get('currentProduct') === 'platecrate_pro') {
    window.subscriptionFlow.productType = 'platecrate-pro';
    document.querySelector("[subscription_type]").innerHTML = 'Plate Crate Pro';
    this._currentTab(1)  
    // document.querySelector("[data-third-step]").classList.add("d-none");
      // document.querySelector("[data-nav-forth-tab]").remove()
   }else if (window.location.search == '?currentProduct=platecrate_lite') {
    window.subscriptionFlow.productType = 'platecrate-lite';
    document.querySelector("[subscription_type]").innerHTML = 'Plate Crate Lite';
    //changing tab number when it's pc lite product
    document.querySelector("[data-nav-third-tab]").querySelector("span").textContent = 2;
    document.querySelector("[data-nav-second-tab]").remove();
    document.querySelector("[data-nav-forth-tab]").remove();
    document.querySelector("[data_crate_badge]").parentElement.classList.add("d-none")
   }
   else{
    window.subscriptionFlow.productType = 'platecrate';
    document.querySelector("[subscription_type]").innerHTML = 'Plate Crate Classic';
    document.querySelector("[data-pro-atc]").remove();
    this._currentTab(1)
   }

   if(document.querySelectorAll("[data-subscription-type-info]").length > 0){
    document.querySelectorAll("[data-subscription-type-info]").forEach(ele=>{
      let type = ele.getAttribute("data-subscription-type-info");
      if(type == window.subscriptionFlow.productType){
        ele.classList.remove('d-none');
      }
    })
   }

const urlParams = new URLSearchParams(window.location.search);

// Check if 'first_crate' is present
if (urlParams.has('first_crate')) {
    // Get and decode the value of 'first_crate'
    let firstCrate = decodeURIComponent(urlParams.get('first_crate'));
  firstCrate = firstCrate
   .replace(/_/g, '')      
   .split('-')            
   .map(word => 
       word.charAt(0).toUpperCase() + 
       word.slice(1).toLowerCase()
   )
   .join('');  
   // Output: "Everything Crate"
    window.globalVariables.first_crate_title = firstCrate;
    window.subscriptionFlow.crateSKU = firstCrate; 
    window.subscriptionFlow.crateName = firstCrate;
    document.querySelector('[data_crate_badge]').innerText = firstCrate;
    document.querySelector('[data-nav-forth-tab]')?.classList.add("d-none");
    const element = document.querySelector('[data-nav-third-tab]');
    element.classList.add('remove-before');
    document.querySelector("[data-third-step] span").innerHTML = `Bring It Home <span class="spinner"></span>`;
    
} 
if (urlParams.has('product_handle')){
const handle = urlParams.get('product_handle');
this.getAvailableSizes(handle);
}
   if (window.outerWidth < 768) {
   this.stickyNextButton();
  }

 

  // manage steps
  document.querySelectorAll("[data-active-tab]").forEach(ele=>{
    ele.addEventListener("click",(event)=>{
      this._manageTab(event);
    })
  })

  //next tab content
  document.querySelectorAll("[data-btn-tab]").forEach(ele=>{
    ele.addEventListener("click",(event)=>{
      this._nextStep(event);
    })
  });

  //select shipping frequency
  document.querySelectorAll("[data-ship-frequency]").forEach(ele=>{
    ele.addEventListener("click",(event)=>{
      this._getSubscriptionFrequency();
    });
  });

   //check payments detials
    document.querySelectorAll("[data-pay-frequency]").forEach(ele=>{
      ele.addEventListener("click",(event)=>{
        this._checkPayDetials(event);
      })
    });

    //4th tab choose crate
    document.querySelectorAll("[data-first-crate-checkbox]").forEach(ele=>{
      ele.addEventListener("click",(event)=>{
        this._selectCrate(event);
      })
    });

    if( window.outerWidth <= 991){
        document.querySelectorAll("[data-tool-tip] svg").forEach(ele => {
          ele.addEventListener("click", (event) => {
            event.stopPropagation(); // prevent triggering document click
            let subElement = event.currentTarget;
            document.querySelectorAll("[data-tool-tip]").forEach(subele => {
              if (subele.classList.contains("open") && subElement !== subele) {
                subele.querySelector(`[data-type="content"]`).classList.remove("open");
                subele.classList.remove("open");
              }
            });
            
            let parentElement = subElement.closest("[data-tool-tip]");
            parentElement.classList.add("open");
            parentElement.querySelector(`[data-type="content"]`).classList.add("open");
          });
        });

        // Close tooltip when clicking outside
        document.addEventListener("click", (event) => {
          document.querySelectorAll("[data-tool-tip].open").forEach(openEl => {
            const svgEl = openEl.querySelector("svg");
            if (!svgEl.contains(event.target)) {
              openEl.querySelector(`[data-type="content"]`).classList.remove("open");
              openEl.classList.remove("open");
            }
          });
        });
    }
    

  }

  stickyNextButton(){
      const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
              let ele = entry.target;
              if(entry.isIntersecting){
                ele.querySelector(".checkoutbtn-sticky").classList.remove('active');
              } else {
                ele.querySelector(".checkoutbtn-sticky").classList.add('active');
              }
          })
      });
          
    
      document.querySelectorAll("[data-next-flow-btn]").forEach(ele=>{
        observer.observe(ele);
      })
  
  }

async getAvailableSizes(handle) {
  try {
    const response = await fetch(`/products/${handle}.js`);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const product = await response.json();

     specialCrate = product.variants;

    // You can filter sizes if needed:
         const availableTitles = product.variants
      .filter(v => v.available)
      .map(v => v.title);




      // Loop through all inputs with data_size_dropdown attribute
    document.querySelectorAll('input[data_size_dropdown]').forEach(input => {
      const title = input.getAttribute('data_size_dropdown');
      if (!availableTitles.includes(title)) {
        // const label = input.closest('label');
        // if (label) label.remove(); // remove full label + input
        // else input.remove();
        input.disabled = true;
      }
    });

    var size_cookie = Utility.getCookie('size_cookie');
    if(size_cookie != '' && size_cookie != undefined){
     if(!availableTitles.includes(size_cookie)){
      document.querySelector(`[data_size_dropdown="${availableTitles[0]}"]`).dispatchEvent(new Event('change'));

      const targetRadio = document.querySelector(`input[data_size_dropdown][value="${availableTitles[0]}"]`);
   
      if (targetRadio) {
        targetRadio.checked = true;
        targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
     }
    }

    return availableTitles;
  } catch (error) {
    console.error('Error fetching product data:', error);
    return null;
  }
}

  _setCrateInfo(){
    if (window.subscriptionFlow.productSize != null) {
        document.querySelector('[data_crate_size]').innerText = window.subscriptionFlow.productSize;
       let urlData = new URLSearchParams(window.location.search);
        if (urlData.has('first_crate')) {
        let  shortNameForSize = window.subscriptionFlow.productSize;
          shortNameForSize = shortNameForSize.match(/\b(\w)/g); // ['J','S','O','N']
          shortNameForSize = shortNameForSize.join(''); // JSON
          if (shortNameForSize == 'YX') {
            shortNameForSize = "YXL"
          }
          if (window.subscriptionFlow.productSize == 'Adult XXL') {
            shortNameForSize = 'AXXL'
          }else if(window.subscriptionFlow.productSize == 'Adult XL') {
            shortNameForSize = 'AXL'
        }
          window.subscriptionFlow.crateSKU =  window.subscriptionFlow.crateName + '-' + shortNameForSize;
        }
    };
    if (window.subscriptionFlow.age != null) {
      document.querySelector('[data_crate_age]').innerText = window.subscriptionFlow.age;
    };
    if (window.subscriptionFlow.positon != null) {
      document.querySelector('[data_crate_position]').innerText = window.subscriptionFlow.positon;
    }

    if (window.subscriptionFlow.productSize != null && window.subscriptionFlow.age != null && window.subscriptionFlow.positon != null) {
      document.querySelector("[data-first-tab-btn]").classList.remove("disabled");
    }


    if (window.subscriptionFlow.frequency != null && stepNumber != 1) {
      if (window.subscriptionFlow.frequency == 'Bi-monthly') {
        document.querySelector('[data_crate_frequency]').innerText = "Every Other Month";
      }else{
      document.querySelector('[data_crate_frequency]').innerText = window.subscriptionFlow.frequency;
      }
    }
    if (window.subscriptionFlow.payFrequency != null) {
      let payfre;
      if (window.subscriptionFlow.payFrequency == 1) {
        payfre = "Monthly"
      }else if(window.subscriptionFlow.payFrequency == 2){
        payfre = "Bi-Monthly"
      }
      else if(window.subscriptionFlow.payFrequency == 3){
        payfre = "every 3 Months"
      }
      else if(window.subscriptionFlow.payFrequency == 6){
        payfre = "every 6 Months"
      }
      else if(window.subscriptionFlow.payFrequency == 12){
        payfre = "Yearly"
      }
      
      if (stepNumber == 3) {
      
        if (window.subscriptionFlow.payFrequency == window.subscriptionFlow.shipFrequency) {
        document.querySelector('[data_crate_price]').innerText = `Pay $${(parseFloat(window.subscriptionFlow.per_crate_price).toFixed(2))} ${payfre}`;  
        }else{
          
          document.querySelector('[data_crate_price]').innerText = `Pay ${window.subscriptionFlow.subTotal} ${payfre}`;

        }

        // if(window.subscriptionFlow.shipFrequency == 2){
          if(window.subscriptionFlow.payFrequency == window.subscriptionFlow.shipFrequency){
            let shippingText = 'Every Other Month';
            if(window.subscriptionFlow.shipFrequency == 2){
              shippingText = 'Every Other Month';
            }else if(window.subscriptionFlow.shipFrequency == 1){
              shippingText = 'Every Month';
            }else if(window.subscriptionFlow.shipFrequency == 3){
              shippingText = 'Every 3 Months';
            }
            document.querySelector('[data_crate_price]').innerText = `${shippingText} ($${(parseFloat(window.subscriptionFlow.per_crate_price).toFixed(2))})`;  
          }else{
            let crateCount = window.subscriptionFlow.payFrequency / window.subscriptionFlow.shipFrequency;
            let crateTotol = window.subscriptionFlow.subTotal.trim();
            if(window.subscriptionFlow.shipFrequency == 1 || window.subscriptionFlow.shipFrequency == 3){
              if (window.subscriptionFlow.payFrequency == 3) {
                crateCount = 'Every 3rd';
              }else if(window.subscriptionFlow.payFrequency == 6){
                crateCount = 'Every 6th';
              }else if(window.subscriptionFlow.payFrequency == 12){
                crateCount = 'Every 12th';
              }
              document.querySelector('[data_crate_price]').innerText = `${crateCount} Month (${crateTotol})`; 
            }else{
            document.querySelector('[data_crate_price]').innerText = `${crateCount} Crates (${crateTotol})`; 
            } 
          }
        // }

        // Pay $180 every 6 months
        // document.querySelector('[data_crate_price]').innerText = `${payfre} (${window.subscriptionFlow.subTotal})`;

        document.querySelector('[data_crate_subtotal]').innerText = window.subscriptionFlow.subTotal;
        document.querySelector('[data-per-crate]').innerText = `$${ parseFloat(window.subscriptionFlow.per_crate_price).toFixed(2)}`;
        document.querySelector('[data_crate_subtotal_discounted]').innerText = window.subscriptionFlow.discount_amount;
      }
      // Hard coded to update the payment tet when it's PC lite 3 months subscription
      if(window.subscriptionFlow.productType == "platecrate-lite" && window.subscriptionFlow.payFrequency == 3){
        document.querySelector('[data_shipping]').innerHTML = `<span>${window.subscriptionFlow.freeShipping}</span><br><span>(Shipping Total $14.85)</span>`;
      }else{
        document.querySelector('[data_shipping]').innerText = `${window.subscriptionFlow.freeShipping} `;
      }
      window.subscriptionFlow.total = parseFloat(window.subscriptionFlow.subTotal.replace("$" , ''))
     
     
    }
    if (window.subscriptionFlow.crateName != null) {
      document.querySelector('[data_crate_badge]').innerText = window.subscriptionFlow.crateName.toLowerCase();
    }
    document.querySelector('[discounted_price]').classList.add("d-none");
    if(window.subscriptionFlow.discount_code != ''  ){
      if (window.subscriptionFlow.subTotal != null) {
        let discounted_price = window.subscriptionFlow.subTotal
        discounted_price = discounted_price.replace("$" , '');
        let per_create = parseFloat(window.subscriptionFlow.per_crate_price);


        if (window.subscriptionFlow.discount_type == 'fix_amount') {
          window.subscriptionFlow.discount_amount = discounted_price - parseFloat(window.subscriptionFlow.discount_amount);
      
          let per_crate_price = (window.subscriptionFlow.discount_amount/window.subscriptionFlow.payFrequency)*window.subscriptionFlow.shipFrequency;
         
          let price_with_shipping = window.subscriptionFlow.subTotal.replace("$" , '')
          price_with_shipping = parseFloat(price_with_shipping);

          if ( stepNumber == 3) {
          document.querySelector('[data_crate_subtotal_discounted]').innerHTML = ``;
          document.querySelector('[data_crate_subtotal]').innerHTML = `<S>${window.subscriptionFlow.subTotal}</S><span class='text-danger'> $${window.subscriptionFlow.discount_amount}</span>`;
          if (window.subscriptionFlow.shipFrequency == window.subscriptionFlow.payFrequency) {
             per_crate_price = per_crate_price - 4.95
            document.querySelector('[data-per-crate]').innerHTML = `<S>$${(parseFloat(window.subscriptionFlow.per_crate_price).toFixed(2))}</S><span class='text-success'> $${(parseFloat(per_crate_price).toFixed(2))}</span>`
          
         }else{
          document.querySelector('[data-per-crate]').innerHTML = `<S>$${(parseFloat(window.subscriptionFlow.per_crate_price).toFixed(2))}</S><span class='text-success'> $${(parseFloat(per_crate_price).toFixed(2))}</span>`

         }
          document.querySelector('[data_crate_subtotal]').innerHTML = `<S>${window.subscriptionFlow.subTotal}</S><span class='text-success'> $${(parseFloat(window.subscriptionFlow.discount_amount).toFixed(2))}</span>`;
         
        }
        
        }else{
          let discount_percentage = parseFloat(window.subscriptionFlow.discount_amount);
          discounted_price = discounted_price.replace(/,/g, "");
 
          window.subscriptionFlow.per_crate_discount = per_create - (per_create * discount_percentage)/100 ;
          window.subscriptionFlow.discount_amount = discounted_price - (discounted_price * discount_percentage)/100;
        
          // let subscription_price  = parseFloat(window.subscriptionFlow.subscriptionprice.replace("$" , ''));
          // let per_box_price = (subscription_price/window.subscriptionFlow.payFrequency)*window.subscriptionFlow.shipFrequency
       
        if ( stepNumber == 3) {
          if (window.subscriptionFlow.shipFrequency == window.subscriptionFlow.payFrequency) {
            let subtotal = window.subscriptionFlow.subTotal.replace("$" , '');
            subtotal = parseFloat(subtotal);
            let discounted_sub_total = subtotal - ( window.subscriptionFlow.per_crate_price - window.subscriptionFlow.per_crate_discount);
            document.querySelector('[data_crate_subtotal]').innerHTML = `<S>${window.subscriptionFlow.subTotal}</S><span class='text-success'> $${(parseFloat(discounted_sub_total).toFixed(2))}</span>`;
  
          }else{
            document.querySelector('[data_crate_subtotal]').innerHTML = `<S>${window.subscriptionFlow.subTotal}</S><span class='text-success'> $${(parseFloat(window.subscriptionFlow.discount_amount).toFixed(2))}</span>`;

          }
         
          document.querySelector('[data_crate_subtotal_discounted]').innerHTML = ``;
          document.querySelector('[data-per-crate]').innerHTML = `<S>$${(parseFloat(window.subscriptionFlow.per_crate_price).toFixed(2))}</S><span class='text-success'> $${(parseFloat(window.subscriptionFlow.per_crate_discount).toFixed(2))}</span>`
          document.querySelector('[crate_discount_price]') ? document.querySelector('[crate_discount_price]').innerHTML = "$"+(parseFloat(discounted_price) - window.subscriptionFlow.discount_amount).toFixed(2) : '';
          }
        document.querySelector('[discounted_price]').classList.remove("d-none");

        
        }
     }
    }
    
  }

  _manageTab(event){
    let currentEle = event.currentTarget;
    stepNumber =  parseInt(currentEle.getAttribute('data-active-tab'));
    if(stepNumber == 2){
      // stepNumber = 3
    }
    this._currentTab(stepNumber);
  }

  _nextStep(event){
    let currentEle = event.currentTarget;
    stepNumber =  parseInt(currentEle.getAttribute('data-btn-tab'));
    if(stepNumber == 2){
      // stepNumber = 3
    }

    if (stepNumber == 4 && window.globalVariables.first_crate_title != null) {
      window.subscriptionFlow.addToCartBtn = document.querySelector("[data-third-step] [data-btn-tab]")
      subscriptionFunnalCommon.prototype._AddToCart();
    }else{
    // for second tab of pc lite crate
    if(window.subscriptionFlow.productType == 'platecrate-lite' && stepNumber==2){
      stepNumber = 3;
      this._showPCLiteProducts();
      document.querySelector("[data-third-step]").classList.add("d-none");
      document.querySelector("[data-pc-lite-third-step]").classList.remove("d-none");
    }
    this._currentTab(stepNumber)
  }
  }

  _currentTab(stepNumber){
    document.querySelectorAll("[data-active-tab]").forEach(ele=>{
      let currentStep = parseInt(ele.getAttribute('data-active-tab'));
      if (stepNumber == 4 && window.globalVariables.first_crate_title != null) {
        window.subscriptionFlow.addToCartBtn = document.querySelector("[data-third-step] [data-btn-tab]")
        subscriptionFunnalCommon.prototype._AddToCart();
      }else{
        if (currentStep < stepNumber) {
          ele.classList.remove("active");
          ele.classList.remove("disabled");
        }
        else if( currentStep == stepNumber){
          ele.classList.add("active");
          ele.classList.remove("disabled");
        }else{
          ele.classList.remove("active");
          ele.classList.add("disabled");
        }

      }
    });

    document.querySelectorAll("[data-tab-content]").forEach(ele=>{
      let currentContentTab = parseInt(ele.getAttribute("data-tab-content"));
      if (stepNumber == 4 && window.globalVariables.first_crate_title != null) {
        ele.remove()
      }else{
      if (currentContentTab == stepNumber) {
        ele.classList.remove("d-none"); 
      }else{
        ele.classList.add("d-none");
      }
    }
    });

    if (stepNumber == 2 && window.subscriptionFlow.productType !== 'platecrate-lite' ) {
      this._getSubscriptionFrequency();
      this._showProductBasedOnShipFrequency();
      this._checkFourthStepAvailableProducts();
    }

    if (stepNumber == 3 && window.subscriptionFlow.productType !== 'platecrate-lite') {
      this._getSubscriptionFrequency();
      this._showProductBasedOnShipFrequency();
      this._checkFourthStepAvailableProducts();
    }
   
    if (stepNumber == 4) {
      let flag = false;
      document.querySelectorAll("[data-first-crate-checkbox]").forEach(ele=>{
        if (flag == false) {
          ele.dispatchEvent(new Event('click'));
          flag = true;
          ele.checked = true;
         }
       });
      // document.querySelectorAll("#cart-checkoutbtn").forEach(ele=>{
      //   ele.classList.remove("d-none");
      // })
    }else{
      // document.querySelectorAll("#cart-checkoutbtn").forEach(ele=>{
      //   ele.classList.add("d-none");
      // })
    }

    if (stepNumber == 1) {
      ga('send', 'event', 'Subscribe', 'Step 1', 'Get Started'); // add GA event on page load
    }
    else if( stepNumber == 2){
      document.querySelectorAll("[data-ship-frequency]")[0].click();
      ga('send', 'event', 'Personalize', 'Step 2', 'Personalize Your Crate');
    }
    else if( stepNumber == 3){
      let flag = false;
      document.querySelectorAll("[data-pay-frequency]").forEach(ele=>{
       if (flag == false) {
          if (!ele.classList.contains("d-none")) {
          ele.dispatchEvent(new Event('click'));
          ele.querySelector("[pay-radio]").checked = true;   
           
            flag = true;
          }
        }
      });
      subscriptionFunnalCommon.prototype.isAllDetailSelected();
       if (window.subscriptionFlow.productType == 'platecrate-pro') {
        document.querySelectorAll("#cart-checkoutbtn").forEach(ele=>{
          ele.classList.remove("d-none");
        });
       }
      
      ga('send', 'event', 'Shipping Frequency', 'Step 3', 'How often do you want to receive your crate?');
    }
    else if( stepNumber == 4){
      ga('send', 'event', 'Payment', 'Step 4', 'Prepay and Save');
    }
    

  }

  _checkFourthStepAvailableProducts(){
    const selectedSize = window.subscriptionFlow.productSize
    let variantNames = document.querySelectorAll("[plateCrate] [data-fourth-step-variant-name]");
    if(window.subscriptionFlow.productType == 'platecrate-pro' && document.querySelectorAll("[plateCratePRO] [data-fourth-step-variant-name]")){
        variantNames = document.querySelectorAll("[plateCratePRO] [data-fourth-step-variant-name]");
    };
    if(variantNames?.length>0){
      variantNames.forEach((ele)=>{
        let getVariantSize = ele.getAttribute("data-fourth-step-variant-name");
        if(getVariantSize == selectedSize){
          let isAvailable = ele.getAttribute("data-available");
          const parentDiv = ele.parentNode.closest(".firstcrate-block-inner");
          if((isAvailable== "false" || !isAvailable) && (parentDiv && parentDiv != undefined)){
              parentDiv.classList.add("firstcrate-block-inner-disabled");
              parentDiv.querySelector("input").disabled = true;          
          } else{
              parentDiv.classList.remove("firstcrate-block-inner-disabled");
              parentDiv.querySelector("input").disabled = false;
          }
        }
      })
    }  
     if(document.querySelectorAll("[data-first-crate-wrap]").length > 0){
      document.querySelectorAll("[data-first-crate-wrap]").forEach(ele=>{
        let crateEle = ele.querySelector("[data-crate-value]")
        let crateValue = crateEle.value;
        
        if(crateValue != 'surprise' && window.subscriptionFlow.productType == 'platecrate-pro' && ele.querySelector("[platecratePRO]") == null ){
          ele.querySelector("[data-first-crate-checkbox]").classList.add("disabled");
          ele.querySelector("[data-first-crate-checkbox]").checked = false;
          ele.querySelector("[data-first-crate-checkbox]").disabled = true;
        }else if(crateValue != 'surprise' && window.subscriptionFlow.productType == 'platecrate' && ele.querySelector("[platecrate]") == null ){
          ele.querySelector("[data-first-crate-checkbox]").classList.add("disabled");
          ele.querySelector("[data-first-crate-checkbox]").checked = false;
          ele.querySelector("[data-first-crate-checkbox]").disabled = true;
        }
      })
    }
  }

  _getSubscriptionFrequency(){
    document.querySelectorAll("[data-ship-frequency]").forEach(ele=>{
      if (ele.checked) {
        window.subscriptionFlow.frequency = ele.getAttribute("data-ship-frequency");
        let parentEle = ele.closest("[data-tab-content]");
        parentEle.querySelector("[data-btn-tab]").classList.remove("disabled");
        this._setCrateInfo();
        if(window.subscriptionFlow.frequency == 'Mi-monthly' || window.subscriptionFlow.frequency == 'Bi-monthly') {
          window.subscriptionFlow.shipFrequency = 2;
        }else if (window.subscriptionFlow.frequency == 'Monthly'){
          window.subscriptionFlow.shipFrequency = 1;
        }else if (window.subscriptionFlow.frequency == 'Quarterly'){
          window.subscriptionFlow.shipFrequency = 3;
        }
      }

    });
  }

  //show pc lite products

  _showPCLiteProducts(){
    document.querySelectorAll("[data-product-type]").forEach(ele=>{
      let productType = ele.getAttribute("data-product-type");
      if (productType == "platecrate-lite") {
        ele.classList.remove("d-none");
      }else{
        ele.classList.add("d-none");
      }
    });
  };

  //show product based on selected frequency

  _showProductBasedOnShipFrequency(){
    document.querySelectorAll("[data-product-type]").forEach(ele=>{
      let shipFrequency = parseInt(ele.getAttribute('data-ship-frequency'));
      let productType = ele.getAttribute("data-product-type");
      if (productType == window.subscriptionFlow.productType && shipFrequency == window.subscriptionFlow.shipFrequency) {
        ele.classList.remove("d-none");
      }else{
        ele.classList.add("d-none");
      }
    });
  };

  // check payment detials
  _checkPayDetials(event){
    event.stopImmediatePropagation();
    let currentEle = event.currentTarget;
    if(currentEle.classList.contains("d-none")){
      return false;
    }
    // enable checkout btn when buying pc lite subscription
    if(window.subscriptionFlow.productType == 'platecrate-lite'){
      const checkoutBtn = document.querySelector("[data-pc-lite-third-step]").querySelector("button")
      checkoutBtn.classList.remove("disabled")
    }
    
    subscriptionFunnalCommon.prototype.setVariantDetails(currentEle);

    let parentEle = currentEle.closest("[data-tab-content]");
    parentEle.querySelector("[data-btn-tab]").classList.remove("disabled");
    let mainProductId =  currentEle.getAttribute("main_product_id");
    let payFrequency =  parseInt(currentEle.getAttribute("data-pay-frequency"));
    window.subscriptionFlow.subTotal = currentEle.querySelector("[data-sub-total]").innerText;
    window.subscriptionFlow.subscriptionprice = currentEle.querySelector("[data-subscription-price]").innerText;
    window.subscriptionFlow.freeShipping = currentEle.querySelector("[free_shipping]").innerText;
        if( window.subscriptionFlow.freeShipping == "+ S/H"){
     window.subscriptionFlow.freeShipping  =  "+ Shipping & Handling"
    }
    window.subscriptionFlow.payFrequency = payFrequency;
    window.subscriptionFlow.giftVariantId = currentEle.getAttribute("gift_variant_id");
    window.subscriptionFlow.giftNote = currentEle.getAttribute("gift_product_note");

    let isGiftExist = false;
    document.querySelectorAll("[gift_main_product_id]").forEach(ele=>{
      let mainProductIdCheck = ele.getAttribute("gift_main_product_id");
      let prductType = ele.getAttribute("product_type");
      if (mainProductIdCheck == mainProductId && prductType == window.subscriptionFlow.productType ) {
        ele.classList.remove("d-none");
        let freeGiftEleUpdate = ele.clientHeight;
        document.documentElement.style.setProperty('--bs-freegift',`${freeGiftEleUpdate}px`);
        isGiftExist = true;
      }else{
        ele.classList.add("d-none");
      }
    });
    if (isGiftExist == false) {
      window.subscriptionFlow.giftVariantId = null;
    }
    this._setCrateInfo();
  
  }

  //4th step select crate
  _selectCrate(event){
    let shortNameForSize;
    let currentEle = event.currentTarget;
    let parentEle = currentEle.closest("[data-first-crate-wrap]");
    window.subscriptionFlow.crateName = parentEle.querySelector("[data_drate_name]").innerText;
    document.querySelector("[data-submit-subscription]").classList.remove("disabled");
    shortNameForSize = window.subscriptionFlow.productSize;
    shortNameForSize = shortNameForSize.match(/\b(\w)/g); // ['J','S','O','N']
    shortNameForSize = shortNameForSize.join(''); // JSON
    if (shortNameForSize == 'YX') {
      shortNameForSize = "YXL"
    }
     if (window.subscriptionFlow.productSize == 'Adult XXL') {
       shortNameForSize = 'AXXL'
    }else if(window.subscriptionFlow.productSize == 'Adult XL') {
      shortNameForSize = 'AXL'
   }
   
    let crateValue = parentEle.querySelector("[data-crate-value]").value;
    let crateEle = parentEle.querySelector("[data-crate-value]")
    
    if (window.subscriptionFlow.productType == "platecrate-pro") {
      if (parentEle.querySelectorAll("[data-crate-value]")[1]) {
        crateValue = parentEle.querySelectorAll("[data-crate-value]")[1].value;
        crateEle = parentEle.querySelectorAll("[data-crate-value]")[1];
      }
      
    }
    if (crateValue =='surprise') {
      window.subscriptionFlow.crateSKU = 'surprise'
    }else{
   const option = crateEle.querySelector(`select.box-sku-dropdown option[data-variant-title="${window.subscriptionFlow.productSize}"]`);
 
    if (option) {
      const sku = option.getAttribute('data-sku');
      if(option.getAttribute('data-available') == "true"){
        window.subscriptionFlow.crateSKU = sku;
        document.querySelectorAll("[data-next-flow-btn] [data-submit-subscription]").forEach(ele=>{
          ele.classList.remove("disabled");
          ele.querySelector(".add-text").innerHTML = `Bring It Home <span class="spinner"></span>`;
        })
      }else{
         document.querySelectorAll("[data-next-flow-btn] [data-submit-subscription]").forEach(ele=>{
          ele.classList.add("disabled");
          ele.querySelector(".add-text").innerText = 'Sold Out';
        })

      }
   
    }else{
    window.subscriptionFlow.crateSKU =`${crateValue}-${shortNameForSize}`;
    }
    }
    this._setCrateInfo();
  };
}
new subscriptionFunnel()